import React, { createContext } from 'react';

import { getSessionToken } from 'src/apollo/createClient';

export type SiftContextType = {
  sessionId?: string | null;
};

export const SiftContext = createContext<SiftContextType | null>(null);

// Create the context provider
export const SiftContextProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  // Fetch the session token when the component mounts
  const sessionId = React.useMemo(() => {
    return getSessionToken();
  }, []);

  return (
    <SiftContext.Provider value={{ sessionId }}>
      {children}
    </SiftContext.Provider>
  );
};

export const useSift = (skip?: boolean): SiftContextType => {
  const siftContext = React.useContext(SiftContext);
  if(skip) return {};
  if(siftContext === null) {
    throw new Error('useSift must be used within a SiftContextProvider');
  }
  return siftContext;
};
